import React, { ReactNode } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { SCREEN } from '@common/Common';

interface AuthHandler {
  initial: (param: string, hisotry: any) => void;
}

interface AuthProps extends AuthHandler, RouteComponentProps {
  children?: ReactNode;
}

class Auth extends React.Component<AuthProps, {}> {
  constructor(props: AuthProps) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (!this.props.location.pathname.includes(SCREEN.PROXY_LOGIN.URL)) {
      this.props.initial(this.props.location.search, this.props.history);
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

export default withRouter(Auth);
